const state = {
    coupon: null
}

const getters = {
    coupon(state) {
        return state.coupon
    }
}

const mutations = {
    setCoupon(state, coupon) {
        state.coupon = coupon
    },

    clear(state) {
        state.coupon = null
    }
}

const actions = {
    setCoupon({ commit }, coupon) {
        commit('setCoupon', coupon)
    },

    clear({ commit }) {
        commit('clear')
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}